import { render, staticRenderFns } from "./UploadProductFiles.vue?vue&type=template&id=57a41dbe&scoped=true&"
import script from "./UploadProductFiles.vue?vue&type=script&lang=js&"
export * from "./UploadProductFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadProductFiles.vue?vue&type=style&index=0&id=57a41dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a41dbe",
  null
  
)

export default component.exports